export default {
  props: {
    theme: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    classModifiers() {
      return {
        'market-trading-unavailable-v2': true,
        [`market-trading-unavailable-v2--${this.theme}`]: this.theme,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/market-trading-unavailable-v2/market-trading-unavailable-v2.js